import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import SERVER from "../../utils/server";
import { toast } from "sonner";



export interface UsersState {
    user?: any;
    credentials?: any;
    accessToken: string | null;
    refreshToken: string | null;
    status: 'idle' | 'pending' | 'succeeded' | 'failed'
}


const initialState: UsersState = {
    user: JSON.parse(localStorage.getItem("user") || "null"),
    credentials: {},
    accessToken: localStorage.getItem("token") || null,
    refreshToken: localStorage.getItem("refreshToken") || null,
    status: "idle",
  };

export const login = createAsyncThunk(
    'auth/login',
    async (credentials: {}, { rejectWithValue }) => {
        try {
            const response = await SERVER.post('admin/auth/login', credentials);
            localStorage.setItem('loginData', JSON.stringify(response.data));
            window.location.replace('/auth/verification');
            return response.data
        } catch (error:any) {
            const err = error?.response?.data?.message || error?.message || 'Something went wrong';
            toast.error(`${err}`)
            return rejectWithValue(error?.response?.data)
        }
    },
)


export const verifyLogin = createAsyncThunk('auth/otp', 
    async (user: {}, { rejectWithValue,  dispatch  }) => {
        try {
            const response = await SERVER.post('admin/auth/verifyToken', user) as any;

            if(!response.data || response.error){
                return toast.error(response.error || 'Failed to verify OTP, please try agein later')
            }

            if(response.data?.data && response.status === 200){
                const { accessToken, refreshToken, ...payload } = response.data.data;
                console.log('accessToken:', accessToken);
                console.log('refreshToken:', refreshToken);
                console.log('user:', payload);


                localStorage.setItem('token', accessToken);
                localStorage.setItem('refreshToken', refreshToken);

                localStorage.setItem('user', JSON.stringify(payload));

                dispatch(setAuth({ user: payload, accessToken, refreshToken }));
                console.log('dispatched auth');
                
                window.location.replace('/auth/verified');
            }

            return response.data.data
        } catch (error:any) {
            const err = error?.response?.data?.message || error?.message || 'Something went wrong';
            toast.error(`${err}`)
            return rejectWithValue(error?.response?.data)
        }
    }
)






export const forgetPassword = createAsyncThunk(
    'auth/forgetPassword',
    async (credentials: {}, { rejectWithValue }) => {
        try {
            const res = await SERVER.post('admin/auth/forgot-password', credentials);
            if(res.data){
                window.location.replace('/auth/reset-password');
            }
            return res.data;
        } catch (error: any) {
            const err = error?.response?.data?.message || error?.message || 'Something went wrong';
            toast.error(`${err}`)
            return rejectWithValue(error);
        }
    }
)



export const resetPassword = createAsyncThunk(
    'auth/verifyOtp',
    async (credentials: {}, { rejectWithValue }) => {
        try {
            const res = await SERVER.post('admin/auth/reset-password', credentials);
            if(res.data){
                window.location.replace('/auth/verified')
            }
            return res.data;
        } catch (error: any) {
            const err = error?.response?.data?.message || error?.message || 'Something went wrong';
            toast.error(`${err}`)
            return rejectWithValue(error);
        }
    }
)

  

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setAuth: (state, action) => {
            state.user = action.payload.user;
            state.accessToken = action.payload.accessToken;
            state.refreshToken = action.payload.refreshToken;
          },
          logout: (state) => {
            state.user = null;
            state.accessToken = null;
            state.refreshToken = null;
            localStorage.clear();
          },
    },
    extraReducers: (builder) => {
        builder.addCase(login.pending, (state, action) => {
            state.status = 'pending';

        })
        builder.addCase(login.fulfilled, (state, action) => {
            state.status = 'succeeded';
            state.credentials = action.payload;
            toast.success('Successful: Please verify your email')
        })
        builder.addCase(login.rejected, (state, action) => {
            state.status = 'failed';
            state.credentials = action.payload;
        })

        //otp
        builder.addCase(verifyLogin.pending, (state, action) => {
            state.status = 'pending';
            state.user = action.payload;
        })
        builder.addCase(verifyLogin.fulfilled, (state, action) => {
            state.status = 'succeeded';
            state.user = action.payload;
            toast.success('OTP verified successfully!')
        })
        builder.addCase(verifyLogin.rejected, (state, action) => {
            state.status = 'failed';
            // toast.error('OTP not valid or expired')
        })

        
        //forget password
        builder.addCase(forgetPassword.pending, (state, action) => {
            state.status = 'pending';
        })
        builder.addCase(forgetPassword.fulfilled, (state, action) => {
            state.status = 'succeeded';
            state.credentials = action.payload; 
            toast.success('OTP sent')
        })
        builder.addCase(forgetPassword.rejected, (state, action) => {
            state.status = 'failed';
        })


        //reset password
        builder.addCase(resetPassword.pending, (state, action) => {
            state.status = 'pending';
        })
        builder.addCase(resetPassword.fulfilled, (state, action) => {
            state.status = 'succeeded';
            state.credentials = action.payload; 
            toast.success('Password reset successful')
        })
        builder.addCase(resetPassword.rejected, (state, action) => {
            state.status = 'failed';
        })
    },
})

export const { setAuth, logout } = authSlice.actions;
export default authSlice.reducer;
